import { Box, Grid, Typography } from '@mui/material';
import { colors } from '../../../utils/colors';
import LoadingProgress from '../../../components/common/LoadingProgress';
import DocumentCard from './DocumentCard';

const FolderDetails = ({ documents, loading, customerId, projectId, folderId }) => {
  if (loading) {
    return <LoadingProgress loading={loading} />;
  }

  if (documents.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          py: { xs: 6, sm: 8 }
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: colors.text.tertiary,
            mb: 1,
            fontWeight: 600,
            fontSize: { xs: '1rem', sm: '1.125rem', md: '1.25rem' }
          }}
        >
          No Documents Found
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: colors.text.secondary,
            fontSize: { xs: '0.813rem', sm: '0.875rem' }
          }}
        >
          This folder is empty
        </Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={{ xs: 2, sm: 2.5, md: 3 }}>
      {documents.map((doc) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={doc.id}>
          <DocumentCard
            document={doc}
            customerId={customerId}
            projectId={projectId}
            folderId={folderId}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default FolderDetails;
